import {useEffect} from "react";

export default function IFrameTest() {

    useEffect(() => {
        setTimeout(() => {
            window.parent.postMessage(JSON.stringify({
                "authorizationToken": "eyJhbGciOiJIUzUxMiIsInppcCI6IkdaSVAifQ.H4sIAAAAAAAA_5XLQQpCMQxF0b10bCAxr7-NM4dO3UGatgsQQUHcu_26AieBF859pfE839MpSTnCNgYK2NIhecSl73_0WlsUQstOGJOpsQRFFRwblHuWnX-xB0O9VMpVhOBi5DKMzKqWzJX72PFjjn94XMdc-rbuGr9ywBXdSDY3guqKsMpuc4PmjOgtvT-PCNeD3QAAAA.LlQN3Xt2qvpF5p6cgOqSPa7HcrQJn109vCzNF5YGWmRSujjMa8FcIMLOnXL8guJI1ODOLm82G73edX9tvNYT7g",
                "eventType": 510,
                "dateTime": "2024-08-29T19:19:25.509Z",
                "payload": {
                    "value": "success",
                    "metainfo": {
                        "mode": "original"
                    }
                },
                "workflowExecutionId": "ac043a78-5811-4a19-a1e9-998375080de1",
                "transactionReference": "ac043a78-5811-4a19-a1e9-998375080de1",
                "accountId": "ac043a78-5811-4a19-a1e9-998375080de1",
                "customerInternalReference": "ref"
            }), '*');
        },2000)
    })

    return (
        <div>hola desde iframe</div>
    )
}
